import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="section">
      <div className="container">
        <div className="contact-header">
          <h2 className="section-title">Let's Work Together</h2>
          <p className="contact-subtitle">
            Ready to bring your digital vision to life? Let's discuss how we can create 
            something amazing together.
          </p>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-card">
              <h3 className="contact-card-title">Get In Touch</h3>
              <div className="contact-methods">
                <div className="contact-method">
                  <span className="method-label">Email</span>
                  <a href="mailto:ayham.apexonestudio@gmail.com" className="method-value">
                    ayham.apexonestudio@gmail.com
                  </a>
                </div>
                <div className="contact-method">
                  <span className="method-label">Phone</span>
                  <a href="tel:+917019636394" className="method-value">
                    +91 7019636394
                  </a>
                </div>
                <div className="contact-method">
                  <span className="method-label">Location</span>
                  <span className="method-value">India</span>
                </div>
              </div>
            </div>
            
            <div className="contact-card">
              <h3 className="contact-card-title">Follow Me</h3>
              <div className="social-links">
                <a 
                  href="https://www.linkedin.com/in/ayham-netfaji-8b1137300"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  LinkedIn
                </a>
                <a 
                  href="https://github.com/ayham-netfaji"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  GitHub
                </a>
                <a 
                  href="https://www.instagram.com/ayham_netfaji"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  Instagram
                </a>
                <a 
                  href="https://x.com/AyhamNetfaji"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  Twitter
                </a>
              </div>
              
              <div className="resume-download">
                <a 
                  href="https://drive.google.com/open?id=1UmwGrX_STgr1lib6kHUTiBXJSMzDzuYP"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Download Resume
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;